export function stripColon(str: string) {
  return str.replace(/:/g, "");
}

export function isString(str: unknown) {
  return typeof str === "string";
}
